export const getToastErrorQuery = (lang = 'en') => `
{
  findToastErrorSingleton {
    data {
      textError {
        ${lang}
      }
    }
  }
}
  
`;